import { combineReducers } from 'redux';
import { assignAssetModalReducer } from './modal/store/assignAssetModal.reducer';
import { assetsFiltersReducer } from './store/maintenanceStandardAssets.reducer';

export const maintenanceStandardAssetsReducer = combineReducers({
    assignAssetModal: assignAssetModalReducer,
    filters: assetsFiltersReducer,
});
